import AccountService from '../../services/models/AccountService';
import IntegrationService from '../../services/models/IntegrationService';
import { CREATE_ACCOUNT, GET_INTEGRATION_PAYMENT_URL, SET_ACCOUNT } from '../mutations';

const accountService = AccountService.build();
const integrationService = IntegrationService.build();

export default {

    namespaced: true,

    state: {
        
        account: {}

    },

    getters: {

        account: state => state.account,

    },

    mutations: {

        [SET_ACCOUNT]: (state, accountData) => {

            state.account = accountData

        },

    },

    actions: {


        [CREATE_ACCOUNT]: async (context, form) => {

            form.phone = form.phone.match(/\d+/g).join('')

            try {
                
                const response = await accountService.create(form);

                console.log(response)

                localStorage.setItem('token', response.token)

                return response


            } catch (error) {

                console.log(error)

                throw error

            }


        },

        [GET_INTEGRATION_PAYMENT_URL]: async () => {

            try {
                
                return await integrationService.getIntegrationPaymentUrl();

            } catch (error) {

                console.log(error)

                throw error

            }


        },



    }
}